import React, { useState } from 'react';
import { Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../Shared/GlobalContext/ThemeContext';

import MessageBasicInfo from './MessageBasicInfo/MessageBasicInfo';
import MessageDeleteAction from './MessageDeleteAction/MessageDeleteAction';
import MessageEditHistory from './MessageEditHistory/MessageEditHistory';
import MessageErrorInfo from './MessageErrorInfo/MessageErrorInfo';
import MessageFailureInfo from './MessageFailureInfo/MessageFailureInfo';
import MessageInfoSection from './MessageInfoSection/MessageInfoSection';
import MessageMediaDetails from './MessageMediaDetails/MessageMediaDetails';
import MessageReactions from './MessageReactions/MessageReactions';
import MessageReplyContext from './MessageReplyContext/MessageReplyContext';
import MessageStatusTimeline from './MessageStatusTimeline/MessageStatusTimeline';
import MessageTicketInfo from './MessageTicketInfo/MessageTicketInfo';
import MessageTransactionInfo from './MessageTransactionInfo/MessageTransactionInfo';

const MessageDetails = ({ message, onDeleteMessage, onClose }) => {
    const { t } = useTranslation();
    const { isDarkMode } = useTheme();
    const [deleteLoading, setDeleteLoading] = useState(false);

    if (!message) return null;

    return (
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <MessageBasicInfo message={message} isDarkMode={isDarkMode} />
            <MessageErrorInfo message={message} isDarkMode={isDarkMode} />
            <MessageFailureInfo message={message} isDarkMode={isDarkMode} />

            <MessageInfoSection title={t('content')} content={message.content} />
            <MessageInfoSection title={t('agent_analysis')} content={message.agent_analysis} />
            <MessageInfoSection title={t('abuse_information')} content={message.abuse_info} />

            <MessageTransactionInfo transactionInfo={message.transaction_info} isDarkMode={isDarkMode} />
            <MessageTicketInfo ticket={message.ticket} />
            <MessageMediaDetails medias={message.medias} />
            <MessageStatusTimeline status={message.status} sentAt={message.status?.sent_at} />
            <MessageReactions reactions={message.reactions} isDarkMode={isDarkMode} />
            <MessageEditHistory editHistory={message.edit_history} currentContent={message.content} />
            <MessageReplyContext replyToMessage={message.reply_to_message} isDarkMode={isDarkMode} />
            <MessageDeleteAction
                messageId={message.id}
                onDeleteMessage={onDeleteMessage}
                onClose={onClose}
                isDarkMode={isDarkMode}
                deleteLoading={deleteLoading}
                setDeleteLoading={setDeleteLoading}
            />
        </Space>
    );
};

export default MessageDetails;
